var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEraser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "__TEMP__SVG__",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.8 14.8",
    style: {
      enableBackground: "new 0 0 14.8 14.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.1,0.7L4.3,4.5L0.6,8.3C0,9,0,10,0.6,10.6L4,14c0.1,0.1,0.3,0.2,0.6,0.2h9.5v-1.6H8.5l5.7-5.7 c0.6-0.6,0.6-1.6,0-2.2c0,0,0,0,0,0l-3.9-3.9C9.7,0.1,8.7,0.1,8.1,0.7C8.1,0.7,8.1,0.7,8.1,0.7z M4.9,12.6L1.7,9.5l3.8-3.8L6.1,5 L10,9l-3.6,3.6l-0.1,0.1H4.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.c7b8eebc9d88dae0075b0e36de3fe28e.svg";
export { ForwardRef as ReactComponent };